<template>
  <v-flex class="cStatement" data-qa="transferfundsreview-flex-db4si">
    <Loader v-show="loaderEnabled" zIdx="205"/>
    <div class="transferReview" data-qa="transferfundsreview-div-eou70s">
      <v-layout wrap class="ml-2 transferFunds--gradientBGposition" data-qa="transferfundsreview-layout-ei9c063">
        <v-flex xs12 sm12 md12 lg12 xl12
          :style="{ background: dashboardGradient, height: '180px' }"
         data-qa="transferfundsreview-flex-245tip">
          <v-container class="transferFunds--title-padding" data-qa="transferfundsreview-container-4fpu2">
            <v-flex xs12 sm12 md12 lg12 xl12 data-qa="transferfundsreview-flex-lm9955">
              <v-row no-gutters data-qa="transferfundsreview-row-y45o2k">
                <v-layout row wrap class="pb-2" data-qa="transferfundsreview-layout-aa9z6j">
                  <v-flex xs2 sm2 md2 lg1 xl1 class="pr-6 pt-4" data-qa="transferfundsreview-flex-hshqxd">
                    <v-row justify="end" data-qa="transferfundsreview-row-o1g04f">
                      <v-avatar :tile="false" size="35" color="white" data-qa="transferfundsreview-avatar-2jw7zg">
                        <v-icon :color="primaryColor" data-qa="transferfundsreview-icon-qswytk">mdi-sync</v-icon>
                      </v-avatar>
                    </v-row>
                  </v-flex>
                  <v-flex xs9 sm9 md9 lg9 xl9 class="pt-2" data-qa="transferfundsreview-flex-o4zeod">
                    <v-row no-gutters data-qa="transferfundsreview-row-net5j">
                      <font class="text-h5 font-weight-light white--text">
                        {{ $t("transferfunds.title") }}</font
                      >
                    </v-row>
                  </v-flex>
                </v-layout>
              </v-row>
            </v-flex>
          </v-container>
        </v-flex>
      </v-layout>

      <v-flex
        xs12 sm12 md12 lg10 xl10
        class="pl-12 cStatement--overlayCardFlex"
       data-qa="transferfundsreview-flex-qr6snk">
        <v-layout row wrap class="openDepositAcc--content-padding" data-qa="transferfundsreview-layout-jnv2do">
          <v-flex xs12 sm12 md12 data-qa="transferfundsreview-flex-3txupf">
            <v-card data-qa="transferfundsreview-card-bsp77">
              <v-card-text class="text--primary" data-qa="transferfundsreview-card-text-31ifx">
                <v-row no-gutters class="transferfunds--review-content-padding" data-qa="transferfundsreview-row-o5vfke">
                  <DisplayDetails
                    :config="{
                      title: 'Summary',
                      dataList: summaryDetails,
                      translation: 'transferfunds',
                    }"
                    class="pl-5"
                  />
                </v-row>
                <v-row
                  v-if="
                    config.payload.paymentFrequency === 'ONCE' &&
                    isFuturePayment()
                  "
                  no-gutters
                  class="px-8"
                 data-qa="transferfundsreview-row-jsmvu">
                  <v-alert
                    icon="mdi-information-outline"
                    class="v-alert--info"
                   data-qa="transferfundsreview-alert-iwu5tm">
                    <font class="body-2 font-weight-regular">
                      {{ $t("transferfunds.scheduledPaymentInfo") }}
                    </font>
                  </v-alert>
                </v-row>
                <v-row
                  v-if="config.payload.paymentFrequency !== 'ONCE'"
                  no-gutters
                  class="px-8"
                 data-qa="transferfundsreview-row-lqkmq">
                  <v-alert
                    icon="mdi-information-outline"
                    class="v-alert--info"
                   data-qa="transferfundsreview-alert-yxoch">
                    <font class="body-2 font-weight-regular">
                      {{ $t("transferfunds.scheduledRecurringPaymentInfo") }}
                    </font>
                  </v-alert>
                </v-row>
              </v-card-text>

              <v-card-actions class="pl-8 pt-3 pb-8" data-qa="transferfundsreview-card-actions-5vjg8j">
                <v-layout wrap data-qa="transferfundsreview-layout-klcpho">
                  <v-btn
                    @click="goBack"
                    :color="primaryColor"
                    :disabled="disableBtn"
                    outlined
                    class="text-capitalize ma-2 py-2 px-4"
                   data-qa="transferfundsreview-btn-lnrdyg">
                    {{ $t("transferfunds.backButton") }}
                  </v-btn>
                  <v-btn
                    @click="confirmTransfer"
                    :color="primaryColor"
                    :disabled="disableBtn"
                    :width="107"
                    :height="36"
                    class="text-capitalize ma-2 pl-16 pr-16 white--text py-2 px-4"
                   data-qa="transferfundsreview-btn-0p2356">
                    {{ $t("transferfunds.confirmButton") }}
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- OTP -->
      <Modal
        v-if="enableOTP && showOTPScreen"
        @cancel="onOtpModalClose"
        :config="modalConfig.otp"
      >
        <span slot="modalContent" data-qa="transferfundsreview-span-un4jvs">
          <OtpInput :otpConfig="otpSettings" />
        </span>
      </Modal>
      <DownloadPaymentProof v-show="showDownloadPayment" :config="paymentProofDetails"></DownloadPaymentProof>
      <template v-if="!invalidAccount && successDialog">
        <Modal
          v-if="successResponse.standingOrderId || successResponse.transactionReference"
          :config='getPaymentSuccessDialogConfig'
          @btn1Action="newTransferRequest"
          @btn2Action="returnToDashboard"
          @btn3Action="downloadPaymentProofEnabled"
        >
        </Modal>
        <PaymentFailureDialog
          v-else
          :show="true"
          :retry="false"
          :error-list="errorList"
          @goBack="handleGoBack"
          @cancelTransfer="newTransferRequest"
        />
      </template>
    </div>
  </v-flex>
</template>

<script>
import '@/styles/pages/consolidatedStatement.scss'
import commonService from '@/service/commonService.js'
import OtpInput from '@/components/common/OtpInput.vue'
import DisplayDetails from '@/views/common/DisplayDetails.vue'
import event from '@/util/event'
import moment from 'moment'
import preload from '@/util/preload'
import uuid from 'uuid-random'
import Loader from '../../../components/common/Loader.vue'
import PaymentFailureDialog from '../InterBankPayments/common/PaymentFailureDialog.vue'
import DownloadPaymentProof from '@/views/payments/paymentProof/PaymentProofFormat.vue'

const DR = 'DEBIT'
const CR = 'CREDIT'

export default {
  name: 'TransferFundsReview',
  props: {
    config: {
      type: Object,
      default: undefined
    },
    display: {
      type: Object,
      default: undefined
    }
  },
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    OtpInput,
    DisplayDetails,
    Loader,
    PaymentFailureDialog,
    DownloadPaymentProof
  },
  data () {
    return {
      loaderEnabled: false,
      successDialog: false,
      invalidAccount: false,
      successResponse: '',
      failureResponseAPI: '',
      disableBtn: false,
      summaryDetails: [],
      confirmationDetails: [],
      enableOTP: this.$appSettings.defaultConfigurations.enableOTPForPaymentransfer,
      defaultCurrency: this.$appSettings.defaultConfigurations.currencyFormat.currency,
      enableIBANAccountNumberDisplay: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay,
      displayDateFormat: this.$appSettings.defaultConfigurations.dateFormat.uiFormat,
      currentDate: moment().format('YYYY-MM-DD'),
      showOTPScreen: false,
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        },
        successModal: {
          enabled: false,
          persistent: true,
          dataListTranslation: 'transferfunds',
          title: this.$t('transferfunds.transferSuccessful'),
          btn1Label: this.$t('paymentSuccessDialog.button.newTransfer'),
          btn2Label: this.$t('paymentSuccessDialog.button.gotoDashboard'),
          width: 700
        }
      },
      exceededAmount: 0.00,
      maximumAllowedAmount: 0.00,
      isNotice: ['NACC', 'TXNA'].includes(this.display.viewOnly.fromAccType) && 'chargeAmt' in this.display.viewOnly,
      isNoticeAccrued: ['NACC', 'TXNA'].includes(this.display.viewOnly.fromAccType) && this.display.viewOnly?.penaltyDetails?.penaltyAmount,
      customMessage: {
        '40280071_TXLA': this.$t('systemMessages.customMessages.40280071_TXLA.message'),
        40113168: this.$t('systemMessages.customMessages.40113168.message')
      },
      causes: [],
      showDownloadPayment: false,
      paymentProofDetails: {},
      downloadDataDetails: [],
      proofOfPaymentConfiguration: this.$appSettings.defaultConfigurations.proofOfPayment,
      isDownloadPaymentProofEnabled: this.$appSettings.defaultConfigurations.proofOfPayment.enableProofOfPaymentDownload
    }
  },
  created () {
    this.setSummaryData()
    event.$on('IS_OTP_VALID', (val) => {
      this.modalConfig.otp.enabled = true
      this.saveTransferData()
    })
    if (this.isDownloadPaymentProofEnabled) {
      this.modalConfig.successModal.btn3Label = this.$t('paymentSuccessDialog.button.download')
    }
  },
  methods: {
    setSummaryData () {
      const { payload } = this.config
      const { viewOnly } = this.display
      const { customFormatter } = this.$formatter.currency

      this.summaryDetails = []
      this.downloadDataDetails = []
      this.summaryDetails.push(
        {
          label: 'fromLabel',
          value: payload.fromAccount.selectedAccountText,
          subValue: payload.fromAccount.selectedAccountHintText
        },
        {
          label: this.enableIBANAccountNumberDisplay ? 'toLabelIBAN' : 'toLabel',
          value: this.display.viewOnly.toAccount,
          subValue: this.display.viewOnly.senderAccName
        },
        {
          label: 'amountLabel',
          value: customFormatter(payload.transferAmount, viewOnly.senderCurrency)
        }
      )
      this.downloadDataDetails.push(
        {
          label: 'fromAcc',
          value: payload?.fromAccount?.selectedAccountText,
          subValue: this.$formatter.maskNumber(payload?.fromAcc)
        }
      )
      if (!this.display.viewOnly.senderAccName) {
        this.downloadDataDetails.push({
          label: 'toAcc',
          value: this.$formatter.maskNumber(payload?.toAcc)
        })
      } else {
        this.downloadDataDetails.push({
          label: 'toAcc',
          value: this.display?.viewOnly?.toAccount,
          subValue: this.$formatter.maskNumber(payload?.toAcc)
        })
      }
      this.downloadDataDetails.push(
        {
          label: 'amount',
          value: customFormatter(payload?.transferAmount, viewOnly?.senderCurrency)
        }
      )
      if (this.isSourceLisa) {
        this.summaryDetails.push(
          {
            label: 'withdrawalCharge',
            value: customFormatter(this.totalLisaCharges, viewOnly.senderCurrency),
            valueClass: 'red--text'
          }
        )
        this.summaryDetails.push(
          {
            label: 'payeeReceives',
            value: customFormatter(payload.transferAmount - this.totalLisaCharges, viewOnly.senderCurrency)
          }
        )
      }
      if (payload.paymentFrequency !== 'ONCE') {
        this.summaryDetails.push(
          { label: 'frequencyDaysLabel', value: payload.paymentFrequency },
          { label: 'selectTimes', value: payload.frequencyMonths }
        )
        this.downloadDataDetails.push(
          { label: 'frequency', value: payload?.paymentFrequency },
          { label: 'noOfPayments', value: payload?.frequencyMonths }
        )
      }
      if (this.isNotice) {
        if (this.isNoticeAccrued) {
          if (this.display.viewOnly.penaltyDetails.penaltyAmount.value > 0) {
            this.summaryDetails.push({
              label: 'loiCharges',
              value: customFormatter(viewOnly.penaltyDetails.penaltyAmount.value, viewOnly.penaltyDetails?.penaltyAmount?.currency)
            })
          }
          this.summaryDetails.push({
            label: 'payeeReceives',
            value: customFormatter(payload.transferAmount, viewOnly.senderCurrency)
          })
        } else {
          this.summaryDetails.push({
            label: 'loiCharges',
            value: customFormatter(viewOnly.chargeAmt, viewOnly.penaltyDetails?.chargeAmount?.currency)
          })
        }
      }
      this.summaryDetails.push(
        {
          label:
            payload.paymentFrequency !== 'ONCE'
              ? 'paymentStartDate'
              : 'quickPaymentDateLabel',
          value: this.$formatter.formatDate(payload.startDate)
        },
        {
          label: 'reviewNoteLabel',
          value: payload.transferNote
        }
      )
    },
    setConfirmationData () {
      const { payload } = this.config
      const { viewOnly } = this.display
      const { customFormatter } = this.$formatter.currency

      this.confirmationDetails.push(
        {
          label: 'fromLabel',
          value: payload.fromAccount.selectedAccountText,
          subValue: payload.fromAccount.selectedAccountHintText
        },
        {
          label: 'toLabel',
          value: this.display.viewOnly.toAccount,
          subValue: this.display.viewOnly.senderAccName
        },
        {
          label: 'amountLabel',
          value: customFormatter(payload.transferAmount, viewOnly.senderCurrency)
        }
      )
      if (this.isSourceLisa) {
        this.confirmationDetails.push(
          {
            label: 'withdrawalCharge',
            value: customFormatter(this.totalLisaCharges, viewOnly.senderCurrency),
            valueClass: 'red--text'
          }
        )
        this.confirmationDetails.push(
          {
            label: 'payeeReceives',
            value: customFormatter(payload.transferAmount - this.totalLisaCharges, viewOnly.senderCurrency)
          }
        )
      }
      if (payload.paymentFrequency !== 'ONCE') {
        this.confirmationDetails.push(
          {
            label: 'frequencyDaysLabel',
            value: payload.paymentFrequency
          },
          {
            label: 'selectMonthsLabel',
            value: payload.frequencyMonths
          },
          {
            label: 'transactionDate',
            value: this.$formatter.formatDate(this.currentDate)
          }
        )
      }
      this.confirmationDetails.push(
        {
          label:
            payload.paymentFrequency !== 'ONCE'
              ? 'paymentStartDate'
              : 'quickPaymentDateLabel',
          value: this.$formatter.formatDate(payload.startDate)
        },
        {
          label: 'reviewNoteLabel',
          value: payload.transferNote
        }
      )
      if (this.isNoticeAccrued) {
        if (this.display.viewOnly.penaltyDetails.penaltyAmount.value > 0) {
          this.confirmationDetails.push({
            label: 'loiCharges',
            value: customFormatter(viewOnly.penaltyDetails.penaltyAmount.value, viewOnly.penaltyDetails.penaltyAmount.currency)
          })
          this.downloadDataDetails.push({
            label: 'charges',
            value: customFormatter(viewOnly?.penaltyDetails?.penaltyAmount?.value, viewOnly?.penaltyDetails?.penaltyAmount?.currency)
          })
        }
        this.confirmationDetails.push({
          label: 'payeeReceives',
          value: customFormatter(payload.transferAmount, viewOnly.senderCurrency)
        })
      }
    },
    onOtpModalClose () {
      this.modalConfig.otp.enabled = false
      this.disableBtn = false
      this.showOTPScreen = false
    },
    confirmTransfer () {
      this.disableBtn = true
      if (this.enableOTP) {
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
      } else {
        this.saveTransferData()
      }
    },
    newTransferRequest () {
      this.successDialog = false
      this.$emit('refreshAccounts')
      event.$emit('IS_REVIEW_CLEAR', { type: 'Reset' })
    },
    async returnToDashboard () {
      this.loaderEnabled = true
      await preload.getListOfAccounts(
        JSON.parse(sessionStorage.getItem('username'))
      )
      this.loaderEnabled = false
      this.$router.push('/home')
    },
    goBack () {
      event.$emit('IS_REVIEW_CLEAR', { type: 'GoBack' })
    },
    isFuturePayment () {
      return this.config.payload.startDate !== this.currentDate
    },
    saveTransferData () {
      // this.onOtpModalClose()
      if (
        this.config.payload.paymentFrequency === 'ONCE' &&
        this.config.payload.startDate === this.currentDate
      ) {
        this.createFundTransfer()
      } else {
        this.invalidAccount = false
        this.createStandingOrder()
      }
    },
    async createFundTransfer () {
      const transactionReferenceID = uuid()
      const { payload } = this.config
      const { viewOnly } = this.display

      const payloadData = {
        forcePostIndicator: false,
        sourceBranchCode: '00000001',
        sourceId: 'FFDC',
        transactionReference: transactionReferenceID,
        channelId: 'IBI',
        valueDate: moment().format(),
        postingEntries: [
          {
            accountId: payload.fromAcc,
            amount: {
              currency: viewOnly.senderCurrency || this.defaultCurrency,
              amount: this.isSourceLisa
                ? this.toDecimal(payload.transferAmount - this.totalLisaCharges)
                : this.toDecimal(payload.transferAmount)
            },
            creditDebitIndicator: DR,
            narrative: payload.transferNote,
            postingType: this.settings.debitPostingType
          },
          {
            accountId: payload.toAcc,
            amount: {
              currency: viewOnly.senderCurrency || this.defaultCurrency,
              amount: this.payeeCreditAmount
            },
            creditDebitIndicator: CR,
            narrative: payload.transferNote,
            postingType: this.settings.creditPostingType
          }
        ]
      }
      if (this.isNotice) {
        if (!this.isNoticeAccrued) {
          this.addChargePostings(payloadData, this.display.viewOnly.penaltyDetails)
        }
      }
      if (this.isSourceLisa) {
        (this.config.payload?.lisaWithdrawalCharges ?? []).forEach(charge => {
          this.addChargePostings(payloadData, charge)
        })
      }
      const response = await commonService.postTransfer(payloadData)
      if (response && !response.causes) {
        this.successDialog = true
        this.successResponse = response
        this.setConfirmationData()
        event.$emit('is_TransferComplete', true)
      } else {
        if (response && response.internalType === 'OTP-ERROR') {
          event.$emit('otp_validation_failed', response)
          return
        }
        this.onOtpModalClose()
        this.successDialog = true
        const errorCode = response?.causes?.[0]?.code

        this.invalidAccount = ['20020000', '20020001', '40280071', '40113168'].includes(errorCode)
        if (this.invalidAccount) {
          if (this.isPayeeLisa) {
            if (errorCode === '40280071') {
              this.dispatchError('Error', this.customMessage['40280071_TXLA'])
            }
            if (errorCode === '40113168') {
              this.dispatchError('Error', this.customMessage['40113168'])
            }
          }
        }

        if (errorCode === '40205043') {
          const amounts = response.causes[0].message.match(/(\d{1,3}(?:,\d{3})*(?:\.\d{2})?)/g)
          this.exceededAmount = amounts[0]
          this.maximumAllowedAmount = amounts[1]
        }
        this.failureResponseAPI = response?.causes?.length ? response.causes[0].code : false
        this.causes = response?.causes ?? []
        event.$emit('is_TransferComplete', true)
      }
    },
    async createStandingOrder () {
      const payloadData = {
        startDate: this.config.payload.startDate,
        numberOfPayments: this.config.payload.frequencyMonths || '1',
        frequency:
          this.config.payload.paymentFrequency === 'ONCE'
            ? 'DAILY'
            : this.config.payload.paymentFrequency,
        description: this.config.payload.transferNote,
        transferFromAccountDetails: [
          {
            accountId: this.config.payload.fromAcc,
            amount: {
              value: this.config.payload.transferAmount,
              currency:
                this.display.viewOnly.senderCurrency || this.defaultCurrency
            }
          }
        ],
        transferToAccountDetails: [
          {
            accountId: this.config.payload.toAcc,
            amount: {
              value: this.config.payload.transferAmount,
              currency:
                this.display.viewOnly.senderCurrency || this.defaultCurrency
            }
          }
        ]
      }
      const response = await commonService.postStandingOrder(payloadData)
      if (response && !response.causes) {
        event.$emit('is_TransferComplete', true)
        this.invalidAccount = false
        this.successDialog = true
        this.successResponse = response
        this.setConfirmationData()
      } else {
        if (response && response.internalType === 'OTP-ERROR') {
          event.$emit('otp_validation_failed', response)
          return
        }
        this.onOtpModalClose()
        if (response && response.causes && response.causes[0] && response.causes[0].code && (response.causes[0].code === '40280071')) {
          this.invalidAccount = true
        }
      }
    },
    dispatchError (title, content) {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          title,
          width: 400,
          persistent: true,
          saveButton: this.$t('common.okay'),
          content,
          type: 'error',
          component: 'dob-modal'
        }
      })
    },
    addChargePostings (payload, details) {
      const { fromAcc } = this.config.payload

      if (details?.chargeAmount?.value) {
        if (this.isSourceLisa) {
          payload.postingEntries.push({
            accountId: fromAcc,
            amount: {
              currency: details.chargeAmount.currency,
              amount: details.chargeAmount.value
            },
            creditDebitIndicator: DR,
            narrative: details.description,
            postingType: details.transactionCode
          })
        }
        payload.postingEntries.push({
          accountId: details.chargeReceivingAccount,
          amount: {
            currency: details.chargeAmount.currency,
            amount: details.chargeAmount.value
          },
          creditDebitIndicator: CR,
          narrative: details.description,
          postingType: details.transactionCode
        })
      }
      if (details?.taxAmount?.value) {
        if (this.isSourceLisa) {
          payload.postingEntries.push({
            accountId: fromAcc,
            amount: {
              currency: details.taxAmount.currency,
              amount: details.taxAmount.value
            },
            creditDebitIndicator: DR,
            narrative: details.description,
            postingType: details.taxTransactionCode
          })
        }
        payload.postingEntries.push({
          accountId: details.taxReceivingAccount,
          amount: {
            currency: details.taxAmount.currency,
            amount: details.taxAmount.value
          },
          creditDebitIndicator: CR,
          narrative: details.description,
          postingType: details.taxTransactionCode
        })
      }
    },
    handleGoBack () {
      this.successDialog = false
      this.onOtpModalClose()
    },
    toDecimal (amount) {
      const number = Number(amount)
      if (isNaN(number)) {
        return NaN
      }
      return Number(number.toFixed(2))
    },
    downloadPaymentProofEnabled () {
      const { payload } = this.config
      let dataDetails = []
      const exclusionList = this.proofOfPaymentConfiguration.exclusionList
      const isRecurringPayment = payload?.paymentFrequency !== 'ONCE'
      const paymentDateLabel = isRecurringPayment || this.isFuturePayment() ? 'transactionCreationDate' : 'paymentDate'
      const isExistingPaymentDate = this.downloadDataDetails.find(item => item.label === paymentDateLabel)

      if (isExistingPaymentDate) {
        isExistingPaymentDate.value = isRecurringPayment || this.isFuturePayment()
          ? this.$formatter.formatDateTime(this.successResponse?.creationDateTime, {
            outputFormat: `${this.displayDateFormat} hh:mm:ss A`
          })
          : this.successResponse?.postingDate
      } else {
        this.downloadDataDetails.push({
          label: paymentDateLabel,
          value: isRecurringPayment || this.isFuturePayment()
            ? this.$formatter.formatDateTime(this.successResponse?.creationDateTime, {
              outputFormat: `${this.displayDateFormat} hh:mm:ss A`
            })
            : this.$formatter.formatDateTime(this.successResponse?.postingDateTime, {
              outputFormat: `${this.displayDateFormat} hh:mm:ss A`
            })
        })
      }
      dataDetails = this.downloadDataDetails?.filter(item => !exclusionList.includes(item.label))
      let titleContentDetails = [
        { label: this.$t('proofOfPayment.label.transactionRef'), value: (this.successResponse?.standingOrderId || this.successResponse?.transactionReference) },
        { label: this.$t('proofOfPayment.label.transactionStatus'), value: this.isFuturePayment() ? this.$t('proofOfPayment.value.processing') : this.$t('proofOfPayment.value.completed') }
      ]
      this.paymentProofDetails = {
        dataDetails,
        titleContentDetails,
        dataListTranslation: 'proofOfPayment.label',
        title: this.$t(this.proofOfPaymentConfiguration.payment_title),
        contentTitle: this.$t(this.proofOfPaymentConfiguration.payment_contentTitle),
        transactionId: (this.successResponse?.standingOrderId || this.successResponse?.transactionId)
      }
      event.$emit('download_payment_proof', this.paymentProofDetails)
    }
  },
  computed: {
    settings () {
      const { fundTransferDebitPostingType, fundTransferCreditPostingType } = this.$appSettings.defaultConfigurations
      return {
        debitPostingType: fundTransferDebitPostingType,
        creditPostingType: fundTransferCreditPostingType
      }
    },
    isSourceLisa () {
      return this.display.viewOnly.fromAccType === 'TXLA'
    },
    isPayeeLisa () {
      return this.display.viewOnly.toAccountType === 'TXLA'
    },
    payeeCreditAmount () {
      const { payload } = this.config

      if (this.isNotice) {
        if (!this.isNoticeAccrued) {
          const { penaltyDetails: penalty = {} } = this.display.viewOnly
          return this.toDecimal(payload.transferAmount - (penalty?.chargeAmount?.value ?? 0) - (penalty?.taxAmount?.value ?? 0))
        }
      }
      if (this.isSourceLisa) {
        return this.toDecimal(payload.transferAmount - this.totalLisaCharges)
      }
      return payload.transferAmount
    },
    errorList () {
      if (!this.failureResponseAPI) {
        return [this.$t('transferfunds.transferFailure')]
      }
      if (this.failureResponseAPI === '40205043') {
        const { exceededAmount, maximumAllowedAmount } = this
        return [this.$t(`systemMessages.customMessages.${this.failureResponseAPI}.message`, { exceededAmount, maximumAllowedAmount })]
      }
      if (this.failureResponseAPI === '40112958') {
        return [this.$t(`systemMessages.customMessages.${this.failureResponseAPI}.message`, { accountNumber: this.config.payload.fromAcc })]
      }
      if (this.$te(`systemMessages.customMessages.${this.failureResponseAPI}.message`)) {
        return [this.$t(`systemMessages.customMessages.${this.failureResponseAPI}.message`)]
      }
      if (this?.causes?.[0]?.message) {
        return [this.causes[0].message]
      }
      return [this.$t('transferfunds.transferFailure')]
    },
    totalLisaCharges () {
      return (this.config.payload?.lisaWithdrawalCharges ?? []).reduce((accumulator, charge) => {
        return accumulator +
          (charge?.chargeAmount?.value ?? 0) +
          (charge?.taxAmount?.value ?? 0)
      }, 0).toFixed(2)
    },
    getPaymentSuccessDialogConfig () {
      return {
        ...this.modalConfig.successModal,
        enabled: this.successResponse.standingOrderId || this.successResponse.transactionReference,
        dataDetails: this.confirmationDetails,
        body: this.$t('paymentSuccessDialog.yourTransactionReference') + ' ' + (this.successResponse.standingOrderId || this.successResponse.transactionReference)
      }
    }
  },
  watch: {
    showOTPScreen () {
      if (this.enableOTP && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  },
  beforeDestroy () {
    event.$off('IS_OTP_VALID'),
    event.$off('download_payment_proof')
  }
}
</script>
